import "@fontsource/inter";
import "@fontsource/inter/700.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/600.css";
import styled from "styled-components";
import { theme } from "../../../theme";

const Body = styled.div<{
  textalign?: string;
  color?: string;
  fontweight?: string;
}>`
  font-family: "Inter", sans-serif;
  font-size: 16px;
  color: ${(props) => props.color ?? theme.colors.text};
  text-align: ${(props) => props.textalign ?? "left"};
  line-height: 1.5rem;
  font-weight: ${(props) => props.fontweight ?? "400"};
`;

export default Body;
